import { generatePath } from 'react-router-dom';
import { Overwrite } from 'utility-types';
import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class ConversationTopicsApi {
  static list = (): Promise<TopicDto[]> =>
    httpClient.get(Endpoint.conversationTopics.list).then(ApiMapper.toResponseData);

  static get = (conversationTopicId: string): Promise<TopicDto> =>
    httpClient
      .get(generatePath(Endpoint.conversationTopics.get, conversationTopicId))
      .then(ApiMapper.toResponseData);

  static create = (topic: Overwrite<TopicDto, { id?: number }>): Promise<TopicDto> =>
    httpClient.post(Endpoint.conversationTopics.create, topic).then(ApiMapper.toResponseData);

  static update = ({ id, ...topic }: TopicDto): Promise<TopicDto> =>
    httpClient
      .patch(generatePath(Endpoint.conversationTopics.upload, { conversationTopicId: id }), topic)
      .then(ApiMapper.toResponseData);

  static remove = (conversationTopicId: number): Promise<void> =>
    httpClient
      .delete(generatePath(Endpoint.conversationTopics.delete, { conversationTopicId }))
      .then(ApiMapper.toResponseData);
}
